import { string, node } from 'prop-types';

const waffle = global.waffle;

export const WaffleSwitch = ({ name, children }) =>
  waffle.switch_is_active(name) ? <>{children}</> : null;

export const WaffleFlag = ({ name, children }) =>
  waffle.flag_is_active(name) ? <>{children}</> : null;

WaffleSwitch.propTypes = {
  name: string.isRequired,
  children: node.isRequired,
};
WaffleFlag.propTypes = {
  name: string.isRequired,
  children: node.isRequired,
};

export default waffle;
